export const AP_FOOTER_TEST_ID = 'AP-Footer';
